// import shop from '../../api/shop'
import { ApiFactory } from "@/api/ApiFactory.js";
const CustomersApi = ApiFactory.get("customers");

// initial state
const state = () => ({
  customers: [],
  customersLoaded: false,
  customersSearching: false,
  customer: {},
  customerLoaded: false,
  customerSearching: false
});

// getters
const getters = {
  getCustomers(state) {
    return state.customers;
  },
  isCustomersLoaded(state) {
    return state.customersLoaded;
  },
  isCustomersSearching(state) {
    return state.customersSearching;
  },

  getCustomer(state) {
    return state.customer;
  },
  isCustomerLoaded(state) {
    return state.customerLoaded;
  },
  isCustomerSearching(state) {
    return state.customerSearching;
  },
  getOrders(state) {
    return state.customer.orders;
  }
};

// actions
const actions = {
  fetchCustomers({ commit, state }, filters) {
    // clear the current store if making a new search
    if (filters.newSearch) commit("SET_CUSTOMERS", []);

    if (state.customers.length == 0) {
      commit("SET_CUSTOMERS_LOADED", false);
      commit("SET_CUSTOMERS_SEARCHING", true);
      return CustomersApi.get(filters).then(response => {
        commit("SET_CUSTOMERS", response.data.body);
        commit("SET_CUSTOMERS_LOADED", true);
        commit("SET_CUSTOMERS_SEARCHING", false);
      });
    }
  },
  fetchCustomer({ commit }, customerId) {
    commit("SET_CUSTOMER", {});
    commit("SET_CUSTOMER_LOADED", false);
    commit("SET_CUSTOMER_SEARCHING", true);
    return CustomersApi.getCustomer(customerId)
      .then(response => {
        commit("SET_CUSTOMER", response.data.body);
        commit("SET_CUSTOMER_LOADED", true);
      })
      .catch(() => {
        commit("SET_CUSTOMER", {});
        commit("SET_CUSTOMER_LOADED", false);
      })
      .finally(() => {
        commit("SET_CUSTOMER_SEARCHING", false);
      });
  }
};

// mutations
const mutations = {
  SET_CUSTOMERS(state, customers) {
    state.customers = customers;
  },
  SET_CUSTOMERS_LOADED(state, loaded) {
    state.customersLoaded = loaded;
  },
  SET_CUSTOMERS_SEARCHING(state, searching) {
    state.customersSearching = searching;
  },
  SET_CUSTOMER(state, customer) {
    state.customer = customer;
  },
  SET_CUSTOMER_LOADED(state, loaded) {
    state.customerLoaded = loaded;
  },
  SET_CUSTOMER_SEARCHING(state, searching) {
    state.customerSearching = searching;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
